import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const root = css`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${spacing.md}px;
  color: var(--neutral-black-70);

  img {
    margin-right: ${spacing.md}px;
  }
`;
